import { FormTokenChainState } from '../types/context';
import { diffFormTokensMeta } from './diffFormTokensMeta';
import { isFormTokensDbAvailable } from './formTokensStorage/isFormTokensDbAvailable';
import { writeFormTokenMetaRecords } from './formTokensStorage/writeFormTokenMetaRecords';

// Last chain persisted per storage key — lets us write only the changed meta
const lastPersistedNodes: Record<string, FormTokenChainState['nodes']> = {};

export const persistFormTokens = (
  localStorageKey: string,
  formTokens: FormTokenChainState
): void => {
  if (!isFormTokensDbAvailable()) {
    return;
  }

  const previousNodes = lastPersistedNodes[localStorageKey] ?? {};
  const { changedRecords, removedIds } = diffFormTokensMeta(
    previousNodes,
    formTokens.nodes
  );
  lastPersistedNodes[localStorageKey] = formTokens.nodes;

  void writeFormTokenMetaRecords(
    localStorageKey,
    changedRecords,
    removedIds
  ).then((succeeded) => {
    if (!succeeded) {
      // force a full rewrite on the next change instead of losing the diff
      delete lastPersistedNodes[localStorageKey];
      console.warn(
        'IndexedDB write failed - form token meta kept in memory only until the next change'
      );
    }
  });
};
